import React from 'react';
import { Box, Card, Title } from '@nimbus-ds/components';
import { DesktopCard, ErrorMessage } from 'commons/components';
import {
  IdentityAlert,
  PendingTrialPeriodAlertPage,
} from 'commons/components/IdentityAlert';
import { useBankAccount, useIdentityValidation } from 'commons/hooks';
import useShowProofOfLifeErrorAlert from 'commons/hooks/useShowProofOfLifeErrorAlert';
import { useTranslationWithPrefix } from 'commons/utils';
import { BankAccount, FiscalDocument, StatusLabel } from '../../shared';
import PersonalDataArgentinaSkeleton from './PersonalDataArgentinaSkeleton';

function PersonalDataArgentina() {
  const { t } = useTranslationWithPrefix('configuration.personalData');
  const identityValidation = useIdentityValidation();
  const bankAccount = useBankAccount();
  const proofOfLifeErrorAlert = useShowProofOfLifeErrorAlert();

  if (bankAccount.isLoading || identityValidation.isLoading) {
    return <PersonalDataArgentinaSkeleton />;
  }
  if (bankAccount.isError || identityValidation.isError)
    return (
      <Card>
        <Card.Header>
          <Title as="h4">{t('cardTitle')}</Title>
        </Card.Header>
        <ErrorMessage />
      </Card>
    );

  const bankName = bankAccount.data.bankName;
  const beneficiaryName = bankAccount.data.holderName;
  const beneficiaryAccountNumber = bankAccount.data.accountNumber;
  const isRegistered = bankAccount.data.isRegistered;
  const fiscalNumber = bankAccount.data.fiscalDocument;
  const validationStatus = identityValidation.data.status;
  const validationStatusDetail = identityValidation.data.statusDetail;
  const validationUpdatedAt = identityValidation.data.updatedAt || '';
  const showPendingProofOfLifeAlert = proofOfLifeErrorAlert.show;

  const renderIdentityAlert = () => {
    return (
      <IdentityAlert
        identityStatus={validationStatus}
        updatedAt={validationUpdatedAt}
        kycDocumentsErrors={identityValidation.data.kycDocumentErrors}
        trialPeriod={identityValidation.data.trialPeriod}
        page={PendingTrialPeriodAlertPage.CONFIGURATION}
        blockedTrialPeriod={identityValidation.data.blockedTrialPeriod}
        statusDetail={validationStatusDetail}
      />
    );
  };

  return (
    <DesktopCard padding="none">
      <Box display="flex" flexDirection="column" gap="4">
        {renderIdentityAlert()}
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Title as="h4">{t('cardTitle')}</Title>
          {showPendingProofOfLifeAlert ? null : (
            <StatusLabel
              statusType={validationStatus}
              statusDetail={validationStatusDetail}
            />
          )}
        </Box>
        <Box display="flex" flexDirection="column" alignItems="stretch" gap="4">
          <FiscalDocument fiscalNumber={fiscalNumber} />
          <BankAccount
            isRegistered={isRegistered}
            bankName={bankName}
            beneficiaryName={beneficiaryName}
            beneficiaryAccountNumber={beneficiaryAccountNumber}
          />
        </Box>
      </Box>
    </DesktopCard>
  );
}

PersonalDataArgentina.displayName = 'PersonalDataArgentina';
PersonalDataArgentina.Skeleton = PersonalDataArgentinaSkeleton;

export default PersonalDataArgentina;
